module.exports = __webpack_public_path__ + "static/media/ONAS_IMAGE.5945e5c7.jpg";